import { FC } from "react"

const Footer: FC<{ onSubmit: () => void, onClose: () => void, disabled: boolean }> = ({ onSubmit, onClose, disabled }) => {
    return (
        <div className="flex-row- align-v- gap-12- brd-c-14- brd-t- p-t-12-">
            <div className="flex-1-"></div>
            <button className="fl-button-2" onClick={onClose}>لغو</button>
            <button className="fl-button-1" disabled={disabled} onClick={onSubmit}>ذخیره</button>
        </div>
    )
}

export default Footer